import { EllipsisVerticalIcon, Trash2Icon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'

import { DeleteStrategyTrigger } from './DeleteStrategyTrigger'

export function StrategyActionsDropdownMenu({ id }: { id: string }) {
	const { t } = useTranslation()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					data-testid='anchor-strategy-actions-trigger'
					variant='ghost'
					size='icon-sm'
				>
					<EllipsisVerticalIcon />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align='end' side='bottom'>
				<DeleteStrategyTrigger id={id}>
					<DropdownMenuItem
						data-testid='anchor-strategy-action-delete'
						variant='destructive'
					>
						<Trash2Icon />
						{t('general_delete')}
					</DropdownMenuItem>
				</DeleteStrategyTrigger>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
